const ListSortType = {
  NULLENUM: 0, // both alert and device
  ALERT_NAME: 1, // alert
  SOURCE: 2, // alert
  TRIGGER: 3, // alert
  CLEAR: 4, // alert
  CURRENT: 5, // alert
  ACTION_COUNT: 6, // alert
  TAG: 7, // both
  DEVICE_NAME: 8, // device & channel
  MODEL: 9, // device
  MAC_ADDRESS: 10, // device & channel
  LAST_MESSAGE: 11, // device
  FIRMWARE: 12, // device
  PUSH_STATUS: 13,
  LINK_STATUS: 14,

  SENSOR_NAME: 15, // channel
  SENSOR_TYPE: 16, // channel
  COMPONENT_NAME: 17, // channel
  // LAST_READING: 18, // channel
  LAST_RECEIVED: 19, // channel
  DEVICE_TYPE: 20, // channel
  SERIAL_NUMBER: 21, // channel
  ALERT_COUNT: 22, // channel
};

export default ListSortType;
